import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../app/services/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../components/default/DefaultCard';

import DefaultModal from '../../components/default/DefaultModal';
import DefaultToolBar from '../../components/default/DefaultToolBar';
import ButtonCreate from '../../components/buttons/ButtonCreate';
import { AuthContext } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import { AppContext } from '../../contexts/AppContext';
import useForeingExchangeService from '../../app/services/hooks/useForeignExchangeService';
import ForeignExchangeDataTable from './components/tables/ForeignExchangeDataTable';
import { useHistory } from 'react-router-dom';
import useNavigationPage from '../../hooks/useNavigationPage';
import { ForeignExchanges,ForeignExchangeFilters } from '../../app/models/ForeignExchange'
import ForeignExchangeCreate from './components/ForeignExchangeCreate';
import ForeignExchangeEdit from './components/ForeignExchangeEdit';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Divisas',
        url: '/foreign-exchanges',
        isActive: true
    }
];

const ForeignExchange = () => {
    const history = useHistory();
    const { auth } = useContext(AuthContext);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { 
        fetchingGetForeignExchanges,
        fetchingDeleteForeignExchange,
        getForeignExchange,
        deleteForeignExchange
    } = useForeingExchangeService();
    const [foreingExchange, setForeingExchange] = useState<ForeignExchanges[]>([]);
    const { navigationPage } = useNavigationPage();

    const [showingCreate, setShowingCreate] = useState(false);
    const [showingManuallyCreate, setShowingManuallyCreate] = useState(false);
    const [showingEdit, setShowingEdit] = useState(false);
    const [foreignExchangeIdEdit, setForeignExchangeIdEdit] = useState<number>(-1);
    const [totalRows, setTotalRows] = useState<number>(0);

    const [foreignExchangeFilter, setForeingExchangeFilter] = useState<ForeignExchangeFilters>({
        page: 1,
        per_page: 10,
        sort: 'exchange_date',
        order: 'desc'
    });

    useEffect(() => {
        reloadTable();
    }, [foreignExchangeFilter.page, foreignExchangeFilter.per_page, foreignExchangeFilter.sort, foreignExchangeFilter.order]);

    const getAllForeingExchange = () => {
        getForeignExchange(foreignExchangeFilter, {
            onSuccess: (response: ServiceResponse) => {
                setForeingExchange(response.data.foreign_exchanges);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });

                if (response.data.to_dashboard) {
                    navigationPage('/');
                }
            }
        });
    };



    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };

    const showManuallyCreate = () => {
        setShowingManuallyCreate(true);
    };

    const hideManuallyCreate = () => {
        setShowingManuallyCreate(false);
    };

    const showEdit = (foreignExchangeId: number) => {
        setShowingEdit(true);
        setForeignExchangeIdEdit(foreignExchangeId);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setForeignExchangeIdEdit(-1);
    };

    const reloadTable = () => {
        getAllForeingExchange();
    };

    const destroy = (foreignExchangeId: number) => {
        const _text = 'Está a punto de eliminar el tipo de cambio #' + foreignExchangeId;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando tipo de cambio...');
                        deleteForeignExchange(foreignExchangeId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El tipo de cambio no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };



    return (
        <>
            <Breadcrumbs pageSection="Divisas" breadcrumbs={breadcrumbs} />

            <DefaultCard>
                {auth &&
                    auth?.permissions &&
                    auth?.permissions.includes('add_foreignexchange') &&
                        (<DefaultToolBar
                            right={<ButtonCreate callbackCreate={showCreate} title="Generar tipo de cambio" />}
                         />)
                }

                {auth &&
                    auth?.permissions &&
                    auth?.permissions.includes('add_foreignexchange') &&
                        (<DefaultToolBar
                            right={<ButtonCreate callbackCreate={showManuallyCreate} title="Crear tipo de cambio manualmente" />}
                        />)
                }

                <ForeignExchangeDataTable
                    foreignExchanges={foreingExchange}
                    loading={fetchingGetForeignExchanges}
                    filter={foreignExchangeFilter}
                    setFilter={setForeingExchangeFilter}
                    totalRows={totalRows}
                    callbackSuccess={reloadTable}
                    onSearch={reloadTable}
                    edit={showEdit}
                    destroy={destroy}
                />
            </DefaultCard>

            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear tipo de cambio"
                    backdrop={true}
                    showFooter={false}
                >
                    <ForeignExchangeCreate
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                    />
                </DefaultModal>
            ) : null}

            {showingManuallyCreate ? (
                <DefaultModal
                    show={showingManuallyCreate}
                    handleClose={hideManuallyCreate}
                    title="Crear tipo de cambio manualmente"
                    backdrop={true}
                    showFooter={false}
                >
                    <ForeignExchangeCreate
                        onSaved={() => {
                            reloadTable();
                            hideManuallyCreate();
                        }}
                        onCancel={hideManuallyCreate}
                        manually={true}
                    />
                </DefaultModal>
            ) : null}

            {showingEdit ? (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title="Editar tipo de cambio"
                    backdrop={true}
                    showFooter={false}
                >
                    <ForeignExchangeEdit
                        foreignExchangeId={foreignExchangeIdEdit}
                        onSaved={() => {
                            reloadTable();
                            hideEdit();
                        }}
                        onCancel={hideEdit}
                        onError={hideEdit}
                    />
                </DefaultModal>
            ) : null}

        </>
    );
};

export default ForeignExchange;
